var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerMenueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.9375,
    height: 5.24286,
    rx: 2.62143,
    fill: "#FABB18"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0625,
    y: 15.7285,
    width: 10.9375,
    height: 5.24286,
    rx: 2.62143,
    fill: "#FABB18"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 7.86426,
    width: 10.9375,
    height: 13.1071,
    rx: 5.46875,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0625,
    width: 10.9375,
    height: 13.1071,
    rx: 5.46875,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenueLogo);
export default __webpack_public_path__ + "static/media/Hamburger Menue Logo.daaaa89c47d942e2af3f07844dccb9b7.svg";
export { ForwardRef as ReactComponent };